import React from 'react'
import Error from '../components/Error/Error'

function ErrorPage() {
  return (
    <Error />
  )
}

export default ErrorPage;